<template>
	<div class="pagination">
		<router-link :to="{ query: {...$route.query, p: prev }}" v-show="p > 1" title="Previous Page">
			<ion-icon  name="arrow-dropleft"></ion-icon>
		</router-link>
		<div class="pagination__page">
			Page {{ p }}
		</div>
		<router-link :to="{ query: {...$route.query, p: next }}" v-show="count >= limit" title="Next Page">
			<ion-icon  name="arrow-dropright"></ion-icon>
		</router-link>
	</div>
</template>

<script>
export default {
	name: 'Pagination',
	props: {
		count: Number,
		limit: Number,
	},
	data: () => ({
		next: 1,
		prev: 1,
	}),
	computed: {
		route() {
			return this.$route
		},
		p() {
			return Number(this.route.query.p || 1)
		},
		// prev() {
		// 	return Math.max(1, (this.p - 1))
		// },
		// next() {
		// 	return this.p + 1
		// },
	},
	watch: {
		count: {
			immediate: true,
			handler: function (val) {
				this.prev = Math.max(1, (Number(this.$route.query.p || 1) - 1) )
				this.next = (Number(this.$route.query.p || 1) + 1)
			},
		},
		$route: {
			immediate: true,
			handler: function (val) {
				this.prev = Math.max(1, (Number(this.$route.query.p || 1) - 1) )
				this.next = (Number(this.$route.query.p || 1) + 1)
			},
		},
	},
}
</script>

<style scoped lang="scss">
.pagination {
	@include modules.gutter('padding');
	align-items: center;
	color: modules.color_('text');
	display: flex;
	justify-content: center;
	line-height: 1;

	a {
		border: 1px solid modules.color_('border');
		border-radius: 4px;
		line-height: 0;
		display: flex;
		align-items: center;
		justify-content: center;
		height: 36px;
		width: 36px;

		&:hover {
			background-color: modules.color_('primary');
			border-color: modules.color_('primary');
		}
	}

	ion-icon {
		color: modules.color_('text', 'light');
		cursor: pointer;
		font-size: 24px;
		transition: color 150ms linear;

		&:hover {
			color: #fff;
		}
	}

	&__page {
		@include modules.fontSize(15px);
		@include modules.gutter('margin-right');
		@include modules.gutter('margin-left');
		font-weight: 500;
	}
}
</style>
